import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../common/reduxQuery/helpers";
import { EventBody, EventHttpMethod } from "../interfaces/categorizationEvents";
import { KeyByAny } from "../../documentSet/interfaces/overview";
import {
  OptionType,
  DerivedData,
  DerivedUpsertRequest,
} from "../interfaces/classifier";

export const metadataApi = createApi({
  reducerPath: "metadataApi",
  baseQuery: customBaseQuery("PUBLIC_API_DATA"),
  endpoints: (build) => ({
    // The endpoint is configured per categorization event, so the response is
    // arbitrary JSON that callers read by the property names in the config map.
    callEvent: build.query<KeyByAny, EventBody>({
      query: ({ endpoint, bodyParams, httpMethod }) => {
        if (httpMethod === EventHttpMethod.GET) {
          return {
            url: `/${endpoint}`,
            method: httpMethod,
          };
        }

        return {
          url: `/${endpoint}`,
          method: httpMethod,
          body: bodyParams,
        };
      },
    }),
    getCategorizationOptions: build.query<
      Array<OptionType>,
      { recordIds: string[] }
    >({
      query: ({ recordIds }) => ({
        url: "/data/api/v1/external-data/web-format-bulk",
        method: "POST",
        body: recordIds,
      }),
    }),
    getDerivedData: build.query<Array<DerivedData>, { endpoint: string }>({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "GET",
      }),
    }),
    upsertDerivedRecords: build.mutation<
      Array<OptionType>,
      DerivedUpsertRequest
    >({
      query: (request) => ({
        url: "/data/api/v1/external-data/derived/upsert-bulk",
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const {
  useLazyCallEventQuery,
  useLazyGetCategorizationOptionsQuery,
  useLazyGetDerivedDataQuery,
  useUpsertDerivedRecordsMutation,
} = metadataApi;
